/**
 * Created by xixue on 2018/3/24.
 */
/* 匹配测试环境正式环境api */
/* eslint-disable */
let root = process.env.CH_API_ROOT
let rootUrl = window.location.host
let learnUrl = ''
let virtualSchoolId = ''

switch (rootUrl) {
  case 'test-dl.171xue.com': // 测试环境线上
  case 'dl.test.171xue.com':
  case 'test-dl.classba.cn':// 测试环境线下
  case 'jzjx.test.classba.cn':
    root = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'jzjx.test.classba.cn'
    learnUrl = `${window.location.protocol}//learn.test.classba.cn`
    virtualSchoolId = 2028
    break
  case 'dl.171xue.com': // 测试环境线上api-dl.test.classba.cn
  case 'dl.classba.cn':// 测试环境线下
  case 'dl.songshuai.com':// 测试环境线下
  case 'jzjx.classba.cn': // 精准教学
    root = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'jzjx.classba.cn'
    learnUrl = `${window.location.protocol}//learn.classba.cn`
    virtualSchoolId = 2399
    break
  default:
    // root = (window.location.protocol === 'https:' ? 'https://' : 'http://') +'tan-dl.classba.cn'
    root = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'jzjx.test.classba.cn'
    // root = (window.location.protocol === 'https:' ? 'https://' : 'http://') +'yuan-dl.classba.cn'
    // root = (window.location.protocol === 'https:' ? 'https://' : 'http://') +'zhu-dl.classba.cn'
    learnUrl = `${window.location.protocol}//learn.test.classba.cn`
    virtualSchoolId = 2028
    // root = 'http://test-module-api.classba.cn'
}

/* 匹配测试环境正式环境api */
let root2 = process.env.API_ROOT
switch (rootUrl) {
  case 'module-cn.classba.cn':
    root2 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'module-api.classba.cn'
    break
  case 'module-cn.171xue.com':
    root2 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'module-api.171xue.com'
    break
  case 'test-module-cn.classba.cn':
    root2 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'test-module-api.classba.cn'
    break
  case 'test-module-cn.171xue.com':
    root2 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'test-module-api.171xue.com'
    break
  case 'test-math-web.classba.cn':
    root2 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'test-s-math.classba.cn'
    break
  default: root2 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'module-api.171xue.com'
}
export { root, root2, learnUrl, virtualSchoolId }
